import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { ChatWidget } from "./ChatWidget";
import { ChatWidgetLayoutStyle, ChatContentStyle, ChatFooterStyle, FooterTextStyle } from "./Styles";
import { ChatHeader } from "./ChatHeader";

const MemoizedChatWidget = React.memo(ChatWidget);

const ChatWidgetLayout = ({
  collapsed,
  shouldLoadHistory,
  clearChatHistory,
  handleAfterConversationCreated,
  selectedConversationId,
  handleAfterLoadingSelectedConversation,
  onChatCleared,
  headerProps
}) => {
  const { t } = useTranslation();
  const isIntroPanelShown = useSelector((state) => state.aiChatBot.isIntroPanelShown);

  return (
    <ChatWidgetLayoutStyle collapsed={collapsed}>
      {collapsed && headerProps && (
        <ChatHeader
          onNewChat={headerProps.onNewChat}
          collapsed={headerProps.collapsed}
          onCollapsed={headerProps.onCollapsed}
        />
      )}
      <ChatContentStyle>
        <MemoizedChatWidget
          {...{
            shouldLoadHistory,
            clearChatHistory,
            handleAfterConversationCreated,
            selectedConversationId,
            handleAfterLoadingSelectedConversation,
            onChatCleared
          }}
        />
      </ChatContentStyle>
      {!isIntroPanelShown && (
        <ChatFooterStyle>
          <FooterTextStyle>{t("ai_chat_bot.chat_footer")}</FooterTextStyle>
        </ChatFooterStyle>
      )}
    </ChatWidgetLayoutStyle>
  );
};
export { ChatWidgetLayout };
